import { supabase } from './supabaseClient';

// Get partner's progress
export async function getProgress(partnerId) {
  const { data, error } = await supabase
    .from('progress')
    .select('*')
    .eq('user_id', partnerId)
    .order('date', { ascending: false })
    .limit(30);
  
  if (error) throw error;
  return data;
}

// Get partner's content
export async function getContent(partnerId) {
  const { data, error } = await supabase
    .from('partner_notes')
    .select('*')
    .eq('partner_id', partnerId)
    .order('created_at', { ascending: false });
  
  if (error) throw error;
  return data;
}

// Save a note for partner
export async function saveNote(userId, partnerId, note) {
  const { error } = await supabase
    .from('partner_notes')
    .insert({
      user_id: userId,
      partner_id: partnerId,
      note: note
    });
  
  if (error) throw error;
}

// Delete a note
export async function deleteNote(noteId) {
  const { error } = await supabase
    .from('partner_notes')
    .delete()
    .eq('id', noteId);
  
  if (error) throw error;
}

// Get notes for a user
export async function getNotes(userId) {
  const { data, error } = await supabase
    .from('partner_notes')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });
  
  if (error) throw error;
  return data;
}

// Get progress by date range
export async function getProgressByDateRange(userId, startDate, endDate) {
  const { data, error } = await supabase
    .from('progress')
    .select('*')
    .eq('user_id', userId)
    .gte('date', startDate)
    .lte('date', endDate)
    .order('date', { ascending: true });
  
  if (error) throw error;
  return data;
}

// Get symptoms by date range
export async function getSymptomsByDateRange(userId, startDate, endDate) {
  const { data, error } = await supabase
    .from('symptoms')
    .select('*')
    .eq('user_id', userId)
    .gte('date', startDate)
    .lte('date', endDate)
    .order('date', { ascending: true });
  
  if (error) throw error;
  return data;
}

// Get water intake by date range
export async function getWaterByDateRange(userId, startDate, endDate) {
  const { data, error } = await supabase
    .from('water_tracking')
    .select('*')
    .eq('user_id', userId)
    .gte('date', startDate)
    .lte('date', endDate)
    .order('date', { ascending: true });
  
  if (error) throw error;
  return data;
}

// Generate random partner code
export function generatePartnerCode() {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let code = '';
  for (let i = 0; i < 6; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
}

// Link partner by code - USES SECURE RPC FUNCTION
export async function linkPartner(userId, code) {
  console.log('=== linkPartner called ===');
  console.log('userId:', userId);
  console.log('code:', code);
  
  if (!userId || !code) {
    return { success: false, error: 'Missing user ID or code' };
  }

  const cleanCode = code.trim().toUpperCase();
  console.log('cleanCode:', cleanCode);

  try {
    // Use the secure RPC function to bypass RLS
    console.log('Calling link_partner_secure RPC...');
    const { data, error } = await supabase.rpc('link_partner_secure', {
      p_user_id: userId,
      p_partner_code: cleanCode
    });

    console.log('RPC result:', { data, error });

    if (error) {
      console.error('RPC error:', error);
      return { success: false, error: `Database error: ${error.message}` };
    }

    if (!data) {
      return { success: false, error: 'No response from server' };
    }

    console.log('Link result:', data);
    return data;

  } catch (err) {
    console.error('Link partner error:', err);
    return { success: false, error: `Unexpected error: ${err.message}` };
  }
}

// Save progress for a date
export async function saveProgress(userId, date, data) {
  const { error } = await supabase
    .from('progress')
    .upsert({
      user_id: userId,
      date: date,
      ...data
    }, { onConflict: ['user_id', 'date'] });
  
  if (error) throw error;
}

// Save symptoms for a date
export async function saveSymptoms(userId, date, symptoms) {
  const { error } = await supabase
    .from('symptoms')
    .upsert({
      user_id: userId,
      date: date,
      symptoms: symptoms
    }, { onConflict: ['user_id', 'date'] });
  
  if (error) throw error;
}

// Save water intake
export async function saveWaterIntake(userId, cups) {
  const today = new Date().toISOString().split('T')[0];
  const { error } = await supabase
    .from('water_tracking')
    .upsert({
      user_id: userId,
      date: today,
      cups: cups
    }, { onConflict: ['user_id', 'date'] });
  
  if (error) throw error;
}

// Get water intake for today
export async function getWaterIntake(userId) {
  const today = new Date().toISOString().split('T')[0];
  const { data, error } = await supabase
    .from('water_tracking')
    .select('*')
    .eq('user_id', userId)
    .eq('date', today)
    .maybeSingle();
  
  if (error) throw error;
  return data;
}